import type { CreditSearchCourse, CreditSearchSubject } from './api'
import type { CreditSearchPreviewCourse, CreditSearchPreviewSubject } from './preview'

export function courseSelectionKey(course: CreditSearchCourse): string {
  return [
    course.institution_id,
    course.external_course_name,
    course.course_code,
    course.course_name,
  ].map((value) => String(value ?? '')).join('|')
}

export function subjectSelectionKey(subject: CreditSearchSubject): string {
  return [subject.institution_id, subject.subject_code, subject.subject_name]
    .map((value) => String(value ?? ''))
    .join('|')
}

export function previewSubjectSelectionKey(
  course: CreditSearchPreviewCourse,
  subject: CreditSearchPreviewSubject,
): string {
  return subjectSelectionKey({
    institution_id: course.institution.id,
    institution_name: course.institution.name,
    subject_code: subject.external_subject_code,
    subject_name: subject.subject_name,
  })
}

export function pageCount(total: number, limit: number): number {
  if (total <= 0 || limit <= 0) return 1
  return Math.max(1, Math.ceil(total / limit))
}

export function pageCanMovePrevious(offset: number): boolean {
  return offset > 0
}

export function pageCanMoveNext(offset: number, limit: number, total: number): boolean {
  return limit > 0 && offset + limit < total
}
